let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2EH1Q")).then(() => parcelRequire('aVc4f'));